(function () {
  function run() {
    const qp = new URLSearchParams(window.location.search);
    const rating = parseInt(qp.get('rating') || '0', 10);
    const emailFromUrl = qp.get('email') || '';
    const order = qp.get('order') || '';
    const success = qp.get('success');

    // ✅ HIER DEINE MAKE CUSTOM WEBHOOK URL EINTRAGEN:
    const MAKE_WEBHOOK_URL = 'https://hook.eu1.make.com/4o92puekp30i2boahaw17i1wvkd1n3mu';

    const headline = document.getElementById('headline');
    const high = document.getElementById('high');
    const low = document.getElementById('low');
    const chooser = document.getElementById('chooser');

    if (!headline || !high || !low || !chooser) return;

    function hideAll() {
      high.style.display = 'none';
      low.style.display = 'none';
      chooser.style.display = 'none';
    }

    // Success-Zustand
    if (success === '1') {
      const h1 = document.querySelector('h1');
      if (h1) h1.style.display = 'none';

      headline.textContent = '';
      hideAll();

      if (!document.getElementById('wltnSuccessCard')) {
        headline.insertAdjacentHTML(
          'afterend',
          `
          <div id="wltnSuccessCard" style="max-width:560px;margin:30px auto 0;padding:26px;border:1px solid #e8e8e8;border-radius:18px;background:#fff;box-shadow:0 6px 24px rgba(0,0,0,0.06);text-align:center;">
            <div style="display:inline-flex;align-items:center;justify-content:center;width:56px;height:56px;border-radius:999px;background:#f3fdf6;border:1px solid #d6f5df;margin-bottom:16px;">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M20 6L9 17l-5-5" stroke="#16a34a" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h2 style="margin:0 0 10px;font-size:20px;font-weight:600;line-height:1.2;">
              Erfolgreich gesendet
            </h2>
            <p style="margin:0;color:#444;font-size:15px;line-height:1.6;">
              Wir haben deine Rückmeldung erhalten und kümmern uns darum.
            </p>
          </div>
          `
        );
      }

      return;
    }

    const ratingField = document.getElementById('ratingField');
    const metaField = document.getElementById('metaField');
    const emailField = document.getElementById('emailField');

    if (emailField && emailFromUrl) emailField.value = emailFromUrl;

    const metaParts = [];
    if (order) metaParts.push('Order: ' + order);
    if (emailFromUrl) metaParts.push('Email: ' + emailFromUrl);

    if (metaField) metaField.value = metaParts.join(' | ');
    if (ratingField) ratingField.value = String(rating || '');

    hideAll();

    // Kein rating vorhanden -> QR-Code / Direktaufruf: zuerst Sterneauswahl zeigen
    if (!rating) {
      headline.textContent = 'Wir freuen uns über dein Feedback.';
      chooser.style.display = 'block';

      const ratingLinks = chooser.querySelectorAll('[data-rating]');
      ratingLinks.forEach((link) => {
        if (!link.dataset.bound) {
          link.dataset.bound = 'true';

          link.addEventListener('click', function (e) {
            e.preventDefault();

            const selectedRating = this.getAttribute('data-rating');
            const url = new URL(window.location.href);

            url.searchParams.set('rating', selectedRating);

            if (order) url.searchParams.set('order', order);
            if (emailFromUrl) url.searchParams.set('email', emailFromUrl);

            window.location.href = url.toString();
          });
        }
      });

      return;
    }

    // 4–5 Sterne -> Trustpilot
    if (rating >= 4) {
      headline.textContent = `Du hast ${rating} Sterne gewählt – danke dir!`;
      high.style.display = 'block';

      setTimeout(() => {
        window.location.href = 'https://www.trustpilot.com/evaluate/wellentine.de';
      }, 1200);

      return;
    }

    // 1–3 Sterne -> Formular + Make Webhook
    if (rating >= 1) {
      headline.textContent = `Du hast ${rating} Sterne gewählt – danke für dein ehrliches Feedback.`;
      low.style.display = 'block';

      const form = document.getElementById('wltnFeedbackForm');

      if (form && !form.dataset.bound) {
        form.dataset.bound = 'true';

        form.addEventListener('submit', (e) => {
          e.preventDefault();

          const messageEl = form.querySelector('textarea[name="contact[Nachricht]"]');
          const emailEl = form.querySelector('#emailField');

          const message = (messageEl && messageEl.value ? messageEl.value.trim() : '');
          const emailVal = ((emailEl && emailEl.value) || emailFromUrl || '').trim();

          if (!message) {
            alert('Bitte gib kurz an, was wir verbessern können.');
            return;
          }

          if (!MAKE_WEBHOOK_URL || MAKE_WEBHOOK_URL.includes('MEINE URL')) {
            alert('Webhook URL fehlt. Bitte MAKE_WEBHOOK_URL in feedback.js setzen.');
            return;
          }

          function upsertHidden(name, value) {
            let el = form.querySelector(`input[name="${name}"]`);
            if (!el) {
              el = document.createElement('input');
              el.type = 'hidden';
              el.name = name;
              form.appendChild(el);
            }
            el.value = value;
          }

          upsertHidden('rating', String(rating));
          upsertHidden('order', order || '');
          upsertHidden('email', emailVal);
          upsertHidden('message', message);
          upsertHidden('meta', metaField ? metaField.value : '');

          const prevAction = form.action;
          form.action = MAKE_WEBHOOK_URL;
          form.method = 'post';

          form.submit();

          form.action = prevAction || '#';

          setTimeout(() => {
            window.location.href = '/pages/feedback?success=1';
          }, 250);
        });
      }

      return;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();